import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CommonButton from "./CommonButton";
import Link from "next/link";
import Image from "next/image";
import homeBanner from "../../public/assets/images/home-banner.png"; 
import homeBannerAssets from "../../public/assets/images/home-banner-assets.png"; 
import "./components.css";
import { HomeBg, HomeImg, HomeRight } from "./svg";
import { event } from "@/lib/analytics";

const Hero = () => {
  const primaryRef = useRef(null);
  const fastRef = useRef(null);
  const fasterRef = useRef(null);
  const fastestRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;

      const offset = (speed) => ({
        x: (clientX - centerX) / speed,
        y: (clientY - centerY) / speed,
      });
      
      const slow = offset(60);
      const fast = offset(30);
      const faster = offset(20);
      const fastest = offset(15);

      if (primaryRef.current)
        primaryRef.current.style.transform = `translate(${slow.x}px, ${slow.y}px)`;
      if (fastRef.current)
        fastRef.current.style.transform = `translate(${fast.x}px, ${fast.y}px)`;
      if (fasterRef.current)
        fasterRef.current.style.transform = `translate(${faster.x}px, ${faster.y}px)`;
      if (fastestRef.current)
        fastestRef.current.style.transform = `translate(${fastest.x}px, ${fastest.y}px)`;
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="hero-main position-relative">
      <HomeBg className="hero-main-bg primary-color" />
      <HomeRight className="hero-main-right primary-color" />
      <Container>
        <Row className="gy-4" style={{ zIndex: 1 }}>
          <Col
            xl={6}
            lg={6}
            md={12}
            className="align-self-center"
            style={{ position: "relative", zIndex: 1 }}
          >
            <h1 className="animation-bottom text-center text-lg-start">
              Looking for your product development? <br />
              <span className="hero-dot">You are at the right place!</span>{" "}
              <br />
              Know the reason?
            </h1>

            <div className="d-flex gap-3 animation-bottom justify-content-center justify-content-lg-start">
              <Link
                href={"https://calendly.com/greet_at_neoverce/30min"}
                role="button"
                target="_blank"
                aria-label={`Book a Call with us`}
              >
                <CommonButton
                  label="Book a Call with us"
                  className="btn-primary"
                  onClick={() =>
                    event({
                      action: "book call",
                      params: { page: "home page" },
                    })
                  }
                />
              </Link>
              <Link href="/pricing" aria-label={`View Pricing page`}>
                <CommonButton
                  label="View Pricing"
                  variant="outline"
                  className="white-border"
                  onClick={() =>
                    event({
                      action: "view pricing",
                      params: { page: "home page" },
                    })
                  }
                />
              </Link>
            </div>
          </Col>
          <Col xl={6} lg={6} md={12} className="align-self-center">
            <div className="homeBanner">
              <div className="position-relative d-flex justify-content-center">
                <Image
                  height={500}
                  width={500}
                  src={homeBanner}
                  alt="neoverce"
                  className="img-fluid "
                  priority
                  fetchPriority="high"
                />
                <Image
                  height={500}
                  width={500}
                  src={homeBannerAssets}
                  alt="neoverce"
                  className="img-fluid home-banner-assets"
                  priority
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Hero;
